export default "__VITE_ASSET__2b40f2a9__"